// extracted by mini-css-extract-plugin
export default {"counter_btns":"Counter_counter_btns__hJtD8","count":"Counter_count__qaHxO","mainDiv":"Counter_mainDiv__6rsOr","bgColor":"Counter_bgColor__ziQq5"};